import { render, staticRenderFns } from "./corona.vue?vue&type=template&id=7ae2d00b"
import script from "./corona.vue?vue&type=script&lang=js"
export * from "./corona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports